import { render, staticRenderFns } from "./VProjectSubstatus.vue?vue&type=template&id=aba9a37c&scoped=true&"
import script from "./VProjectSubstatus.vue?vue&type=script&lang=js&"
export * from "./VProjectSubstatus.vue?vue&type=script&lang=js&"
import style0 from "./VProjectSubstatus.vue?vue&type=style&index=0&id=aba9a37c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba9a37c",
  null
  
)

export default component.exports